// Marca da plataforma: cada módulo é apresentado como um produto GovHub (ex.: "GovHub-Ouvidoria")
export const PLATFORM_NAME = 'GovHub';

const productSuffixes: Record<number, string> = {
    1: 'Publicações',
    2: 'Remessas',
    3: 'Portal',
    4: 'SIC',
    7: 'Ouvidoria',
    9: 'Contratações',
    10: 'Emendas',
};

export const getProductName = (moduleId?: number): string => {
    const suffix = moduleId !== undefined ? productSuffixes[moduleId] : undefined;
    return suffix ? `${PLATFORM_NAME}-${suffix}` : PLATFORM_NAME;
};
